import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { InformationCardsComponent } from './information-cards.component'
import { SharedModule } from '../shared/shared.module'
import { CardComponent } from './card/card.component'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'
import { MobileComponent } from './mobile/mobile.component'
import { DesktopComponent } from './desktop/desktop.component'
import { LoadScrollService } from 'dmmp-services'
import { PipesModule } from '../../pipes/pipes.module'

@NgModule({
  declarations: [
    InformationCardsComponent,
    CardComponent,
    MobileComponent,
    DesktopComponent,
  ],
  imports: [CommonModule, SharedModule, InfiniteScrollModule, PipesModule],
  exports: [InformationCardsComponent],
  providers: [LoadScrollService],
})
export class InformationCardsModule {}
